import React from 'react';
import clsx from 'clsx';
import { Grid } from 'semantic-ui-react';
import selectors from '../hooks/selectors';
import HomePanelLauncher from './HomePanelLauncher';
import configuration from '../constants';

const HomePanelLaunchers = ({ compact }) => {
  const { launchers } = selectors.useHomePanelLaunchers();
  if (!launchers.length) {
    return null;
  }

  return (
    <>
      <Grid.Row
        className={clsx(
          'aridhia-home-launcher-row',
          launchers.length > configuration.MAX_ITEMS && 'aridhia-home-launcher-row--extra',
          compact && 'aridhia-home-launcher-row--compact',
        )}
      >
        {launchers.map((item) => (
          <Grid.Column className="border-l p-0" key={item.name}>
            <HomePanelLauncher item={item} compact={compact} />
          </Grid.Column>
        ))}
      </Grid.Row>
    </>
  );
};

export default HomePanelLaunchers;
